export const categories = [
  {
    id: 'yulequan',
    name: '娱乐圈',
    slug: 'yulequan',
    description: '娱乐圈最新爆料、明星八卦、影视圈内幕',
    icon: 'ri-movie-line',
  },
  {
    id: 'wanghong',
    name: '网红圈',
    slug: 'wanghong',
    description: '网红黑料、主播八卦、社交媒体达人爆料',
    icon: 'ri-live-line',
  },
  {
    id: 'mingxing',
    name: '明星八卦',
    slug: 'mingxing',
    description: '明星私生活、恋情曝光、人设崩塌',
    icon: 'ri-star-line',
  },
  {
    id: 'zongyi',
    name: '综艺节目',
    slug: 'zongyi',
    description: '综艺内幕、节目争议、嘉宾黑历史',
    icon: 'ri-tv-line',
  },
  {
    id: 'yinyue',
    name: '音乐圈',
    slug: 'yinyue',
    description: '歌手爆料、音乐节内幕、版权风波',
    icon: 'ri-music-line',
  },
  {
    id: 'shipin',
    name: '影视剧集',
    slug: 'shipin',
    description: '剧组内幕、演员争议、制片八卦',
    icon: 'ri-clapperboard-line',
  },
];